import { render, staticRenderFns } from "./DisplayPage.vue?vue&type=template&id=fdac9296&scoped=true&"
import script from "./DisplayPage.vue?vue&type=script&lang=js&"
export * from "./DisplayPage.vue?vue&type=script&lang=js&"
import style0 from "./DisplayPage.vue?vue&type=style&index=0&id=fdac9296&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdac9296",
  null
  
)

export default component.exports